import { render } from "./WidgetAssignUserGroup.vue?vue&type=template&id=0fb11dc4&ts=true"
import script from "./WidgetAssignUserGroup.vue?vue&type=script&lang=ts"
export * from "./WidgetAssignUserGroup.vue?vue&type=script&lang=ts"

import "./WidgetAssignUserGroup.vue?vue&type=style&index=0&id=0fb11dc4&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__